var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100%","width":"100%","border":"none","overflow":"hidden"},attrs:{"src":_vm.dashboardUrl,"onload":"javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+\"px\";}(this));"}})}
var staticRenderFns = []

export { render, staticRenderFns }